/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import { Select, MenuItem } from "@mui/material";
import pr from "../lib/pr";

// const [centers, setCenters] = useState([
//   { cid: 0, center: "", location: "" },
// ]);

function CenterSelect(props) {
  const { login, tcidParent, setTcidParent } = props;
  const [rows, setRows] = useState([]);
  const [tcid, setTcid] = useState('');

  // 가맹점 로드
  // 500 모든센터 (최고관리자)
  // 100 자기센터 (점장)
  // 50 자기센터 (직원)
  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/center_list"
    );
    let tmp_rows = result.data;

    // 두써킷 센터만 > 백엔드에서 처리
    // tmp_rows = tmp_rows.filter(el => el.cid === 'CID00000009' 
    // || el.cid === 'CT17X10111035.huwy5'
    // || el.cid === 'CT14Z01170314.HXZb9'
    // || el.cid === 'CT14S15143839.Pdfg3'
    // || el.cid === 'CID00000017'
    // || el.cid === 'CID00000018'
    // );

    if (login.level !== "500") {
      tmp_rows = tmp_rows.filter((el) => el.cid === login.cid);
      setTcid(login.cid);
      setTcidParent(login.cid);
    }
    setRows(tmp_rows);
  };
  useEffect(() => {
    if (login.level !== "") {
      load_data();
    }
  }, [login.level]);

  // 수정시
  useEffect(() => {
    if (tcidParent !== '') {
      setTcid(tcidParent);
    }
  }, [tcidParent])

  // return (
  //   <FormControl>
  //     <InputLabel id="demo-simple-select-label" size="small">가맹점</InputLabel>
  //     <Select
  //       name="tcid"
  //       labelId="demo-simple-select-label"
  //       id="demo-simple-select"
  //       css={css`
  //         width: 260px;
  //       `}
  //       label="가맹점"
  //       size="small"
  //       value={tcid}
  //       onChange={(e) => {
  //         setTcid(e.target.value);
  //         setTcidParent(e.target.value);
  //       }}
  //     >
  //       {rows.map((item, index) => {
  //         return (
  //           <MenuItem value={item.cid} key={index}>
  //             {item.center} :: {item.location}
  //           </MenuItem>
  //         );
  //       })}
  //     </Select>
  //   </FormControl>
  // );


  return (
    <select className="p-2" name="tcid" 
    onChange={(e) => {
      setTcid(e.target.value);
      setTcidParent(e.target.value);
    }}>
      <option value="">가맹점</option>
      {rows.map((item, index) => {
        return (
          <option value={item.cid} key={index}>
            {item.center} :: {item.location}
          </option>
        );
      })}
    </select>
  )


  return <>null</>;
}

export default CenterSelect;
